import { formatDate } from '@angular/common';

export function formatDateForRequest(date: string, locale: string) {
  return formatDate(date ?? '', 'yyyy-MM-dd', locale);
}
